import { jsx } from "react/jsx-runtime";
import { forwardRef, useState, useMemo } from "react";
import PropTypes from "prop-types";
import { CardImpl } from "./card.styles.es.js";
import { cardContext } from "./card-context.es.js";
import "@reach/auto-id";
import "lodash/fp";
import { useHandler } from "../../hooks/use-handler.es.js";
import "styled-components";
import "../../contexts/display-mode-context/display-mode-context.es.js";
import "../../contexts/global-edit-context/global-edit-context.es.js";
import "../../contexts/toast-context/toast-context.es.js";
import "../../utils/is-valid-ref.es.js";
import "../../hooks/use-horizontal-scroll.es.js";
import "react-use-measure";
import "@juggle/resize-observer";
import "@reach/utils";
import "@reach/rect";
import "compute-scroll-into-view";
const { Provider } = cardContext;
const propTypes = {
  children: PropTypes.node.isRequired,
  defaultFocus: PropTypes.bool,
  defaultHover: PropTypes.bool
};
const defaultProps = {
  defaultFocus: false,
  defaultHover: false
};
const Card = forwardRef(({ children, defaultFocus, defaultHover }, ref) => {
  const [hasFocus, setFocus] = useState(defaultFocus);
  const [hasHover, setHover] = useState(defaultHover);
  const handleMouseEnter = useHandler(() => {
    setHover(true);
  });
  const handleMouseLeave = useHandler(() => {
    setHover(false);
  });
  const handleBlur = useHandler(({ currentTarget, relatedTarget }) => {
    if (!currentTarget.contains(relatedTarget)) {
      setFocus(false);
    }
  });
  const handleFocus = useHandler(({ currentTarget, relatedTarget }) => {
    if (!currentTarget.contains(relatedTarget)) {
      setFocus(true);
    }
  });
  const contextValue = useMemo(
    () => ({
      hasFocus,
      hasHover
    }),
    [hasFocus, hasHover]
  );
  return /* @__PURE__ */ jsx(Provider, { value: contextValue, children: /* @__PURE__ */ jsx(
    CardImpl,
    {
      ref,
      onBlur: handleBlur,
      onFocus: handleFocus,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      children
    }
  ) });
});
Card.propTypes = propTypes;
Card.defaultProps = defaultProps;
export {
  Card
};
